import { apiFetch } from '../api/apiClient';
import { getAPIUrl } from '../api/apiUtils';

export const emotions = { joy: 'Радость', anger: 'Гнев', fear: 'Страх', sadness: 'Грусть', surprise: 'Удивление', disgust: 'Отвращение', shame: 'Стыд', calm: 'Спокойствие' };
export const tones = { positive: 'Положительная', negative: 'Отрицательная', neutral: 'Нейтральная', mixed: 'Смешанная' };
export const yesterday = () => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Moscow' }).format(new Date(Date.now() - 86400000));

export async function causalApi(path, body) {
  const response = await apiFetch(`${getAPIUrl()}/llm/${path}`, body === undefined ? {} : {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
  });
  const data = await response.json();
  if (!response.ok) {
    const detail = Array.isArray(data.detail) ? data.detail.map(item => item.msg).join('; ') : data.detail;
    throw new Error(detail || data.error || `Ошибка ${response.status}`);
  }
  return data;
}
